/* RESPONSIBLE TEAM: team-proactive-support */
import PredicateGroup from 'embercom/models/common/predicate-group';

export default PredicateGroup.extend({});
